import React from 'react'
import "../CSS_folder/Contact.css"
import logo from "../logo-no-background.png";
function Contact() {
  return (
    <div id="contact" className="contactContainer">
      <div className="subContactContainer">
        <span
          className="contactLogoItem"
          onClick={() => {
            window.open("https://www.linkedin.com/in/bruceyim/", "_blank");
          }}
        >
          <img
            className="contactLogo"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/600px-LinkedIn_logo_initials.png?20140125013055"
            alt="LinkedIn"
          />
          LinkedIn
        </span>
        <span
          className="contactLogoItem"
          onClick={() => {
            window.open(
              "https://mail.google.com/mail/u/?authuser=bruceyim05@gmail.com",
              "_blank"
            );
          }}
        >
          <img
            className="contactLogo"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Gmail_icon_%282020%29.svg/2560px-Gmail_icon_%282020%29.svg.png"
            alt="Gmail"
          />
          Gmail
        </span>
        <span
          className="contactLogoItem"
          onClick={() => {
            window.open("https://github.com/Chilam-Yim", "_blank");
          }}
        >
          <img
            className="contactLogo"
            src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
            alt="Github"
          />
          Github
        </span>
      </div>
      <div>
        <a href="#header">
          <img
            src={logo}
            style={{ marginTop: "20px", height: "40px", width: "auto" }}
          />
        </a>
      </div>
      <div style={{ marginTop: "20px" }}>Copyright © 2023 Bruce Yim</div>
    </div>
  );
}

export default Contact